import { ROUTE_PATH } from './consts';

export const createProductPageUrl = productId =>
  `${ROUTE_PATH.replace(':productId', productId)}`;
